<div class="parking-space-process-details-container p-2  mx-auto">
    <!-- Header -->
    <div class="flex items-center gap-4 mb-6">
        <button mat-icon-button (click)="goBack()" class="back-button">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div>
            <h1 class="text-3xl font-bold text-gray-900">{{ summary()?.parkingSpaceName || 'Parking Processes' }}</h1>
            <p class="text-sm text-gray-600 mt-1">Parking processes for this parking space</p>
        </div>
    </div>

    <!-- Summary Cards -->
    @if (summary()) {
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <!-- Total Processes -->
        <jjames-card>
            <div class="p-4">
                <div class="flex items-center">
                    <div class="p-3 bg-blue-100 rounded-lg mr-4">
                        <mat-icon class="text-blue-600">receipt_long</mat-icon>
                    </div>
                    <div>
                        <p class="text-sm text-gray-500">Total Processes</p>
                        <p class="text-2xl font-bold text-gray-900">{{ summary()?.totalProcessCount || 0 }}</p>
                    </div>
                </div>
            </div>
        </jjames-card>

        <!-- Active Processes -->
        <jjames-card>
            <div class="p-4">
                <div class="flex items-center">
                    <div class="p-3 bg-green-100 rounded-lg mr-4">
                        <mat-icon class="text-green-600">play_circle</mat-icon>
                    </div>
                    <div>
                        <p class="text-sm text-gray-500">Active</p>
                        <p class="text-2xl font-bold text-green-600">{{ summary()?.activeProcessCount || 0 }}</p>
                    </div>
                </div>
            </div>
        </jjames-card>

        <!-- Completed Processes -->
        <jjames-card>
            <div class="p-4">
                <div class="flex items-center">
                    <div class="p-3 bg-gray-100 rounded-lg mr-4">
                        <mat-icon class="text-gray-600">check_circle</mat-icon>
                    </div>
                    <div>
                        <p class="text-sm text-gray-500">Completed</p>
                        <p class="text-2xl font-bold text-gray-600">{{ summary()?.completedProcessCount || 0 }}</p>
                    </div>
                </div>
            </div>
        </jjames-card>

        <!-- Zones -->
        <jjames-card>
            <div class="p-4">
                <div class="flex items-center">
                    <div class="p-3 bg-purple-100 rounded-lg mr-4">
                        <mat-icon class="text-purple-600">location_on</mat-icon>
                    </div>
                    <div>
                        <p class="text-sm text-gray-500">Zones</p>
                        <p class="text-2xl font-bold text-purple-600">{{ summary()?.zoneSummaries?.length || 0 }}</p>
                    </div>
                </div>
            </div>
        </jjames-card>
    </div>

    <!-- Zone Summaries -->
    @if (summary()?.zoneSummaries && summary()!.zoneSummaries!.length > 0) {
    <jjames-card class="mb-6">
        <div class="p-4">
            <h3 class="text-lg font-semibold mb-4">Zone Summary</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                @for (zone of summary()!.zoneSummaries!; track zone.zoneId) {
                <div class="bg-gray-50 rounded-lg p-3 border border-gray-200">
                    <div class="flex items-center justify-between mb-2">
                        <span class="font-medium text-gray-900">{{ zone.zoneName || 'Unknown Zone' }}</span>
                        <span class="text-sm text-gray-500">{{ zone.totalProcessCount }} total</span>
                    </div>
                    <div class="flex items-center gap-4 text-sm">
                        <span class="text-green-600">
                            <mat-icon class="text-sm align-middle">radio_button_checked</mat-icon>
                            {{ zone.activeProcessCount }} active
                        </span>
                        <span class="text-gray-500">
                            <mat-icon class="text-sm align-middle">check_circle</mat-icon>
                            {{ zone.completedProcessCount }} completed
                        </span>
                    </div>
                </div>
                }
            </div>
        </div>
    </jjames-card>
    }
    }

    <!-- Processes Table -->
    <jjames-card>
        <div class="p-4">
            <!-- Header -->
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
                <h3 class="text-lg font-semibold">Parking Processes</h3>

                <div class="flex items-center gap-3">
                    <!-- Filter Toggle -->
                    <mat-button-toggle-group [value]="selectedFilter()" (change)="onFilterChange($event.value)"
                        class="filter-toggle-group">
                        <mat-button-toggle value="all">All</mat-button-toggle>
                        <mat-button-toggle value="active">Active</mat-button-toggle>
                        <mat-button-toggle value="completed">Completed</mat-button-toggle>
                    </mat-button-toggle-group>

                    <!-- Refresh Button -->
                    <button mat-icon-button (click)="refresh()" [disabled]="isLoading()" matTooltip="Refresh">
                        <mat-icon [class.animate-spin]="isLoading()">refresh</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Search Filters -->
            <div class="mb-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                    <!-- License Plate Autocomplete -->
                    <div class="flex flex-col gap-1">
                        <label class="text-xs font-medium text-gray-600">License Plate</label>
                        <mat-form-field appearance="fill" class="w-full filter-form-field">
                            <mat-icon matPrefix class="text-gray-400 text-base">badge</mat-icon>
                            <input matInput placeholder="Search plate..." [ngModel]="lpSearchTerm()"
                                (ngModelChange)="onLpSearchChange($event)" [matAutocomplete]="lpAuto" />
                            @if (isLoadingLps()) {
                            <mat-spinner matSuffix diameter="16"></mat-spinner>
                            }
                            <mat-autocomplete #lpAuto [displayWith]="displayLp" (optionSelected)="onLpSelected($event.option.value)">
                                @for (lp of filteredLpOptions(); track lp.id) {
                                <mat-option [value]="lp">
                                    <span class="font-medium">{{ lp.fullNumber }}</span>
                                </mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>

                    <!-- Zone -->
                    <div class="flex flex-col gap-1">
                        <label class="text-xs font-medium text-gray-600">Zone</label>
                        <select [ngModel]="zoneFilter()" (ngModelChange)="zoneFilter.set($event)"
                            class="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white">
                            <option value="">All Zones</option>
                            @for (zone of availableZones; track zone.id) {
                            <option [value]="zone.id">{{ zone.name }}</option>
                            }
                        </select>
                    </div>

                    <!-- From Date -->
                    <div class="flex flex-col gap-1">
                        <label class="text-xs font-medium text-gray-600">From Date</label>
                        <input type="date" [ngModel]="startDateFilter()" (ngModelChange)="startDateFilter.set($event)"
                            class="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" />
                    </div>

                    <!-- To Date -->
                    <div class="flex flex-col gap-1">
                        <label class="text-xs font-medium text-gray-600">To Date</label>
                        <input type="date" [ngModel]="endDateFilter()" (ngModelChange)="endDateFilter.set($event)"
                            class="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" />
                    </div>
                </div>

                <div class="flex gap-2 mt-3">
                    <button mat-flat-button color="primary" (click)="applySearchFilters()" [disabled]="isLoading()">
                        <mat-icon class="mr-1">search</mat-icon>
                        Search
                    </button>
                    <button mat-stroked-button (click)="clearFilters()" [disabled]="isLoading()">
                        <mat-icon class="mr-1">clear</mat-icon>
                        Clear
                    </button>
                </div>
            </div>

            <!-- Loading State -->
            @if (isLoading()) {
            <div class="flex items-center justify-center py-12">
                <mat-spinner diameter="40"></mat-spinner>
            </div>
            } @else {
            <!-- Table with Expandable Rows -->
            <div class="mat-elevation-z2 rounded-lg overflow-hidden">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)"
                    multiTemplateDataRows class="w-full processes-table">

                    <!-- Expand Column -->
                    <ng-container matColumnDef="expand">
                        <th mat-header-cell *matHeaderCellDef class="w-12"></th>
                        <td mat-cell *matCellDef="let process">
                            <button mat-icon-button (click)="toggleRow(process); $event.stopPropagation()">
                                <mat-icon class="transition-transform duration-200"
                                    [class.rotate-180]="expandedElement === process">
                                    expand_more
                                </mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let process">
                            <jjames-badge [variant]="getStatusBadgeVariant(process)">
                                {{ getStatusText(process) }}
                            </jjames-badge>
                        </td>
                    </ng-container>

                    <!-- License Plate Column -->
                    <ng-container matColumnDef="licensePlate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>License Plate</th>
                        <td mat-cell *matCellDef="let process">
                            <div class="flex items-center">
                                <mat-icon class="text-blue-500 mr-2 text-base">directions_car</mat-icon>
                                <span class="font-medium">{{ getLicensePlate(process) }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Zone Column -->
                    <ng-container matColumnDef="zone">
                        <th mat-header-cell *matHeaderCellDef>Zone</th>
                        <td mat-cell *matCellDef="let process">
                            <div class="flex items-center">
                                <mat-icon class="text-purple-500 mr-2 text-base">location_on</mat-icon>
                                <span>{{ getZoneName(process) }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Started At Column -->
                    <ng-container matColumnDef="startedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Started</th>
                        <td mat-cell *matCellDef="let process">
                            <span class="text-sm">{{ formatDate(process.startedAt) }}</span>
                        </td>
                    </ng-container>

                    <!-- Duration Column -->
                    <ng-container matColumnDef="duration">
                        <th mat-header-cell *matHeaderCellDef>Duration</th>
                        <td mat-cell *matCellDef="let process">
                            <div class="flex items-center">
                                <mat-icon class="text-orange-500 mr-1 text-base">timer</mat-icon>
                                <span class="text-xs text-gray-600">{{ formatDuration(process.duration) }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Violation Column -->
                    <ng-container matColumnDef="violation">
                        <th mat-header-cell *matHeaderCellDef>Violation</th>
                        <td mat-cell *matCellDef="let process">
                            @if (hasViolation(process)) {
                            <jjames-badge variant="danger">
                                <mat-icon class="text-sm mr-1">warning</mat-icon>
                                {{ getViolationCount(process) }}
                            </jjames-badge>
                            } @else {
                            <span class="text-gray-400 text-sm">-</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Expanded Detail Row -->
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let process" [attr.colspan]="displayedColumns.length">
                            <div class="expanded-detail" [class.expanded]="process === expandedElement">
                                <div class="py-4 px-6 bg-gray-50 border-t border-gray-200">
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

                                        <!-- Process Details -->
                                        <div class="space-y-3">
                                            <h4 class="font-semibold text-gray-800 flex items-center gap-2">
                                                <mat-icon class="text-blue-500">info</mat-icon>
                                                <span>Process Details</span>
                                            </h4>
                                            <div class="space-y-2 text-sm">
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Parker:</span>
                                                    <span class="font-medium">{{ getParkerName(process) }}</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Started:</span>
                                                    <span class="font-medium">{{ formatDate(process.startedAt) }}</span>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Ended:</span>
                                                    @if (process.endedAt) {
                                                    <span class="font-medium">{{ formatDate(process.endedAt) }}</span>
                                                    } @else {
                                                    <jjames-badge variant="success" size="sm">In Progress</jjames-badge>
                                                    }
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Duration:</span>
                                                    <span class="text-xs text-gray-600">{{
                                                        formatDuration(process.duration) }}</span>
                                                </div>
                                                <!-- Which rule admitted this car. Deliberately inside the expanded
                                                     detail and not a table column: it is the engine's own vocabulary,
                                                     useful when a gate did something unexpected, but not something an
                                                     operator should have to read past on every row. -->
                                                @if (process.strategyDetails) {
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Admitted as:</span>
                                                    <span class="text-xs text-gray-600"
                                                        [matTooltip]="process.strategyDetails.description || ''">
                                                        {{ getStrategyName(process) }}
                                                    </span>
                                                </div>
                                                }
                                                @if (process.tariffName) {
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Tariff:</span>
                                                    <span class="font-medium">{{ process.tariffName }}</span>
                                                </div>
                                                }
                                                @if (getPayment(process); as payment) {
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">{{ payment.status === 'Paid' ? 'Paid:' : 'Fee:' }}</span>
                                                    <span class="font-medium">{{ formatAmount(payment) }}</span>
                                                    @if (payment.status !== 'Paid') {
                                                    <span class="text-xs text-gray-500">({{ payment.status }})</span>
                                                    } @else if (payment.paidAt) {
                                                    <span class="text-xs text-gray-500">{{ formatDate(payment.paidAt) }}</span>
                                                    }
                                                </div>
                                                }
                                            </div>
                                            @if (canEditTimes()) {
                                            @if (editingTimesId() === process.id) {
                                            <div class="flex flex-col gap-2 p-3 bg-white rounded border border-gray-200 text-sm">
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Started:</span>
                                                    <div class="datetime-field">
                                                        <input class="date-input" placeholder="TT.MM.JJJJ"
                                                            [matDatepicker]="editStartPicker"
                                                            [ngModel]="editStartDate()" (ngModelChange)="editStartDate.set($event)" />
                                                        <mat-datepicker-toggle class="date-toggle" [for]="editStartPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #editStartPicker></mat-datepicker>
                                                        <span class="divider"></span>
                                                        <input class="time-input" type="text" inputmode="numeric" maxlength="5"
                                                            placeholder="HH:MM"
                                                            [ngModel]="editStartTime()" (ngModelChange)="editStartTime.set($event)" />
                                                    </div>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Ended:</span>
                                                    <div class="datetime-field">
                                                        <input class="date-input" placeholder="TT.MM.JJJJ"
                                                            [matDatepicker]="editEndPicker"
                                                            [ngModel]="editEndDate()" (ngModelChange)="editEndDate.set($event)" />
                                                        <mat-datepicker-toggle class="date-toggle" [for]="editEndPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #editEndPicker></mat-datepicker>
                                                        <span class="divider"></span>
                                                        <input class="time-input" type="text" inputmode="numeric" maxlength="5"
                                                            placeholder="HH:MM"
                                                            [ngModel]="editEndTime()" (ngModelChange)="editEndTime.set($event)" />
                                                    </div>
                                                </div>
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">No charge:</span>
                                                    <mat-slide-toggle color="primary"
                                                        [ngModel]="editCoveredZero()" (ngModelChange)="editCoveredZero.set($event)"></mat-slide-toggle>
                                                </div>
                                                <label class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Reason:</span>
                                                    <input type="text" maxlength="1024" class="border rounded px-2 py-1 flex-1"
                                                        [ngModel]="editTimesReason()" (ngModelChange)="editTimesReason.set($event)" />
                                                </label>
                                                @if (timesError()) {
                                                <span class="text-red-600">{{ timesError() }}</span>
                                                }
                                                <div class="flex justify-end gap-2">
                                                    <button mat-button (click)="cancelEditTimes()" [disabled]="isSavingTimes()">Cancel</button>
                                                    <button mat-raised-button color="primary" (click)="saveTimes(process)"
                                                        [disabled]="isSavingTimes()">Save</button>
                                                </div>
                                            </div>
                                            } @else {
                                            <button mat-stroked-button (click)="startEditTimes(process)">
                                                <mat-icon>edit</mat-icon>
                                                Edit stay
                                            </button>
                                            }
                                            }
                                        </div>

                                        <!-- Location Details -->
                                        <div class="space-y-3">
                                            <h4 class="font-semibold text-gray-800 flex items-center gap-2">
                                                <mat-icon class="text-purple-500">location_on</mat-icon>
                                                <span>Location Details</span>
                                            </h4>
                                            <div class="space-y-2 text-sm">
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">Zone:</span>
                                                    <jjames-badge variant="info">
                                                        {{ getZoneName(process) }}
                                                    </jjames-badge>
                                                </div>
                                                @if (!process.endedAt) {
                                                <div
                                                    class="flex flex-col items-center justify-center gap-2 mt-4 p-3 bg-yellow-50 rounded border border-yellow-200">
                                                    <label class="text-sm text-gray-700 mb-1 font-medium">End Parking
                                                        Process:</label>
                                                    <div class="flex flex-row items-center gap-2 w-full justify-center">
                                                        <input type="datetime-local" [(ngModel)]="process.manualEndDate"
                                                            class="border rounded px-2 py-1 w-48" />
                                                        <button mat-raised-button color="warn"
                                                            (click)="stopProcess(process)">Stop Process</button>
                                                    </div>
                                                </div>
                                                }
                                                <div class="flex items-center gap-2">
                                                    <span class="text-gray-500 w-24">License Plate:</span>
                                                    <jjames-badge variant="secondary">
                                                        <mat-icon class="text-xs mr-1">badge</mat-icon>
                                                        {{ getLicensePlate(process) }}
                                                    </jjames-badge>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Violation Details -->
                                        <div class="space-y-3">
                                            <h4 class="font-semibold text-gray-800 flex items-center gap-2">
                                                @if (hasViolation(process)) {
                                                <mat-icon class="text-red-500">warning</mat-icon>
                                                <span>Violations ({{ getViolationCount(process) }})</span>
                                                } @else {
                                                <mat-icon class="text-green-500">verified</mat-icon>
                                                <span>Compliance Status</span>
                                                }
                                            </h4>
                                            @if (hasViolation(process) && process.violationDetails?.violationItems) {
                                            <div class="space-y-2 max-h-48 overflow-y-auto">
                                                @for (violation of process.violationDetails.violationItems; track
                                                violation.id) {
                                                <div class="bg-red-50 rounded-lg p-3 border border-red-200">
                                                    <div class="flex items-center justify-between mb-1">
                                                        <div class="flex items-center gap-2">
                                                            <mat-icon class="text-red-500 text-base">error</mat-icon>
                                                            <span class="font-medium text-red-700">
                                                                {{ violation.violationType || 'Violation' }}
                                                            </span>
                                                        </div>
                                                        @if (violation.isActive) {
                                                        <jjames-badge variant="danger" size="sm">Active</jjames-badge>
                                                        } @else {
                                                        <jjames-badge variant="secondary"
                                                            size="sm">Resolved</jjames-badge>
                                                        }
                                                    </div>
                                                    @if (violation.description) {
                                                    <p class="text-sm text-red-600 mb-2">{{ violation.description }}</p>
                                                    }
                                                    <div class="text-xs text-gray-500 space-y-1">
                                                        <div class="flex items-center gap-1">
                                                            <mat-icon class="text-xs">schedule</mat-icon>
                                                            <span>Started: {{ formatDate(violation.startedAt) }}</span>
                                                        </div>
                                                        @if (violation.endedAt) {
                                                        <div class="flex items-center gap-1">
                                                            <mat-icon class="text-xs">schedule</mat-icon>
                                                            <span>Ended: {{ formatDate(violation.endedAt) }}</span>
                                                        </div>
                                                        }
                                                        @if (violation.duration) {
                                                        <div class="flex items-center gap-1">
                                                            <mat-icon class="text-xs">timer</mat-icon>
                                                            <span>Duration: {{ formatDuration(violation.duration)
                                                                }}</span>
                                                        </div>
                                                        }
                                                        @if (violation.parkingZoneName) {
                                                        <div class="flex items-center gap-1">
                                                            <mat-icon class="text-xs">location_on</mat-icon>
                                                            <span>Zone: {{ violation.parkingZoneName }}</span>
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                            } @else if (hasViolation(process)) {
                                            <div class="bg-red-50 rounded-lg p-3 border border-red-200">
                                                <div class="flex items-center gap-2">
                                                    <mat-icon class="text-red-500 text-base">error</mat-icon>
                                                    <span class="font-medium text-red-700">
                                                        {{ getViolationCount(process) }} Violation(s) Detected
                                                    </span>
                                                </div>
                                            </div>
                                            } @else {
                                            <div class="bg-green-50 rounded-lg p-3 border border-green-200">
                                                <div class="flex items-center gap-2">
                                                    <mat-icon class="text-green-500 text-base">check_circle</mat-icon>
                                                    <span class="text-green-700 font-medium">No Violations</span>
                                                </div>
                                                <p class="text-sm text-green-600 mt-1">
                                                    This parking session is compliant with all regulations.
                                                </p>
                                            </div>
                                            }
                                        </div>

                                    </div>

                                    <!-- Detection Logs Section -->
                                    @if (getDetectionLogCount(process) > 0) {
                                    <div class="mt-6">
                                        <h4 class="font-semibold text-gray-800 flex items-center gap-2 mb-3">
                                            <mat-icon class="text-teal-500">camera_alt</mat-icon>
                                            <span>Detection Logs ({{ getDetectionLogCount(process) }})</span>
                                        </h4>
                                        <div class="rounded-lg border border-gray-200 overflow-hidden">
                                            <div class="overflow-x-auto overflow-y-auto max-h-52">
                                                <table class="w-full text-sm">
                                                    <thead class="sticky top-0 z-10">
                                                        <tr class="bg-gray-100 text-gray-700 text-left">
                                                            <th class="px-3 py-2 font-medium">Time</th>
                                                            <th class="px-3 py-2 font-medium">Type</th>
                                                            <th class="px-3 py-2 font-medium">Plate</th>
                                                            <th class="px-3 py-2 font-medium">Confidence</th>
                                                            <th class="px-3 py-2 font-medium">Direction</th>
                                                            <th class="px-3 py-2 font-medium">Images</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        @for (log of getDetectionLogs(process); track log.id) {
                                                        <tr class="border-t border-gray-100 hover:bg-gray-50">
                                                            <td class="px-3 py-2 text-gray-700 whitespace-nowrap">
                                                                {{
                                                                formatDate(log.hardwareDetectionDetails?.detectionTime)
                                                                }}
                                                            </td>
                                                            <td class="px-3 py-2">
                                                                <jjames-badge
                                                                    [variant]="getDetectionTypeBadgeVariant(log.detectionType)"
                                                                    size="sm">
                                                                    {{ log.detectionType || '-' }}
                                                                </jjames-badge>
                                                            </td>
                                                            <td class="px-3 py-2">
                                                                <span
                                                                    class="font-mono bg-gray-100 px-2 py-0.5 rounded border text-xs">
                                                                    {{ log.hardwareDetectionDetails?.plateNumber || '-'
                                                                    }}
                                                                </span>
                                                            </td>
                                                            <td class="px-3 py-2 text-gray-700">
                                                                @if (log.hardwareDetectionDetails?.confidence !==
                                                                undefined)
                                                                {
                                                                {{ (log.hardwareDetectionDetails!.confidence! *
                                                                100).toFixed(1) }}%
                                                                } @else {
                                                                -
                                                                }
                                                            </td>
                                                            <td class="px-3 py-2 text-gray-700">
                                                                {{ log.hardwareDetectionDetails?.direction || '-' }}
                                                            </td>
                                                            <td class="px-3 py-2">
                                                                <div class="flex items-center gap-1">
                                                                    @if (log.hardwareDetectionDetails?.vehicleImageUrl)
                                                                    {
                                                                    <button mat-icon-button matTooltip="Vehicle image"
                                                                        class="text-blue-500 hover:text-blue-700"
                                                                        (click)="openPreview(log.hardwareDetectionDetails!.vehicleImageUrl!); $event.stopPropagation()">
                                                                        <mat-icon
                                                                            class="text-base">directions_car</mat-icon>
                                                                    </button>
                                                                    } @else {
                                                                    <span class="text-xs text-gray-400 italic">No
                                                                        vehicle img</span>
                                                                    }
                                                                    @if (log.hardwareDetectionDetails?.plateImageUrl) {
                                                                    <button mat-icon-button matTooltip="Plate image"
                                                                        class="text-teal-500 hover:text-teal-700"
                                                                        (click)="openPreview(log.hardwareDetectionDetails!.plateImageUrl!); $event.stopPropagation()">
                                                                        <mat-icon class="text-base">badge</mat-icon>
                                                                    </button>
                                                                    } @else {
                                                                    <span class="text-xs text-gray-400 italic">No plate
                                                                        img</span>
                                                                    }
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                        class="cursor-pointer hover:bg-gray-50 transition-colors"
                        [class.bg-blue-50]="expandedElement === row"
                        [class.bg-red-50]="hasViolation(row) && expandedElement !== row" (click)="toggleRow(row)">
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

                    <!-- No Data Row -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center py-8" [attr.colspan]="displayedColumns.length">
                            <div class="flex flex-col items-center text-gray-500">
                                <mat-icon class="text-4xl mb-2">local_parking</mat-icon>
                                <span>No parking processes found</span>
                            </div>
                        </td>
                    </tr>
                </table>

                <!-- Paginator -->
                <mat-paginator [length]="totalCount()" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    [pageSizeOptions]="[10, 25, 50, 100]" [showFirstLastButtons]="!isHandset()"
                    (page)="onPageChange($event)">
                </mat-paginator>
            </div>
            }
        </div>
    </jjames-card>
</div>

<!-- Image Preview Lightbox -->
@if (previewImageUrl()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/70" (click)="closePreview()">
    <div class="relative max-w-3xl max-h-[90vh] p-2" (click)="$event.stopPropagation()">
        <button mat-icon-button class="absolute -top-3 -right-3 bg-white shadow-lg z-10" (click)="closePreview()">
            <mat-icon>close</mat-icon>
        </button>
        <img [src]="previewImageUrl()" alt="Detection image"
            class="max-w-full max-h-[85vh] rounded-lg shadow-2xl object-contain" />
    </div>
</div>
}